import React, { FC, useLayoutEffect, useState } from 'react';
import "./DynamicTab.scss";
import { lang } from "./../../models/index";
import {
    addDays,
    endOfDay,
    startOfDay,
    startOfYear,
    startOfMonth,
    endOfMonth,
    endOfYear,
    addMonths,
    addYears,
    startOfWeek,
    endOfWeek,
    isSameDay,
    differenceInCalendarDays
} from "date-fns";
import { enUS, arSA } from "date-fns/locale";
import { DateRangePicker, defaultStaticRanges, defaultInputRanges } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css";
//import { defaultStaticRanges,  defaultInputRanges } from "react-date-range/dist/defaultRanges";

import { useTranslation } from "react-i18next";
import { AiOutlineCalendar, AiOutlineFilter, AiOutlineSearch } from 'react-icons/ai';
import { handleLangugeDirection } from '../../components/commonFunctions';


interface DynamicTab {
    tabs: Array<{ name: string, value: string }>;
    activeTab: string;
    setActive: (active: string) => void;
    renderTabdata?: (activeTab: string) => any;
    showFiler?: string;
}
interface staticRanges {
    Today: string,
    Yesterday: string,
    ThisWeek: string,
    LastWeek: string,
    ThisMonth: string,
    LastMonth: string,
    ThisYear: string,
    LastYear: string
}

interface Dateinfo {
    startDate: Date;
    endDate: Date;
    key?: string;
    color?: string;
    autoFocus?: boolean;
}
const DynamicTab: FC<DynamicTab> = ({ tabs, activeTab, setActive, renderTabdata, showFiler }) => {
    const [state, setState]: any = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
            color: "#00e6a0",
            autoFocus: true,
        }
    ]);

    const [toggledatepicker, setToggledatepicker] = useState(false);
    const { t } = useTranslation('translation', { keyPrefix: "dynamicTab" });
    const staticRangesLabels: staticRanges = t("staticRange", { returnObjects: true });
    const inputRangesLabels = t("inputRange", { returnObjects: true });


    function translateRange(dictionary: any) {
        return (item: any) =>
            dictionary[item.label] ? { ...item, label: dictionary[item.label] } : item;
    }

    const ruStaticRanges = defaultStaticRanges.map(
        translateRange(staticRangesLabels)
    );

    const ruInputRanges = defaultInputRanges.map(translateRange(inputRangesLabels));

    const toggleDatePicker = () => {
        /* console.log("toggle fun ") */
        setToggledatepicker(!toggledatepicker);
    }


    useLayoutEffect(() => {
        if (toggledatepicker) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        }
    }, [toggledatepicker])




    return (
        <div className="tabs-container ">
            <div className="tab-elements">
                {
                    tabs.map((element, index) => {
                        return <p key={index} className={`tab-element ${activeTab === element.name && 'active-ele'}`} onClick={() => setActive(element.name)}>{element.value}</p>
                    })
                }
            </div>
            {showFiler !== "hide" ? null : <div className='filter-container'>
                <div className='left-filter'>
                    <div className='date-filter'>
                        <button className='calender-button' onClick={toggleDatePicker}>{`${(state[0].startDate).toDateString()} - ${(state[0].endDate).toDateString()}`}  <AiOutlineCalendar />   </button>
                        {toggledatepicker && <div className='hover-back' onClick={toggleDatePicker} >
                            <div className='date-filter-container' onClick={(event: any) => { event.stopPropagation() }} >
                                <DateRangePicker
                                    locale={handleLangugeDirection(lang, "locale", {}, { arSA, enUS }) /* lang === "en" ||lang === "fr"? enUS : arSA */}
                                    onChange={(item: any) => setState([item.selection])}
                                    moveRangeOnFirstSelection={false}
                                    maxDate={new Date()}
                                    weekStartsOn={6}
                                    months={1}
                                    ranges={state}
                                    direction="horizontal"
                                    staticRanges={[...ruStaticRanges,
                                    {
                                        label: staticRangesLabels.LastYear,
                                        range: () => ({
                                            startDate: startOfYear(addYears(new Date(), -1)),
                                            endDate: endOfYear(addYears(new Date(), -1))
                                        }),
                                        isSelected(range: any) {
                                            const definedRange: any = this.range();
                                            return (
                                                isSameDay(range.startDate, definedRange.startDate) &&
                                                isSameDay(range.endDate, definedRange.endDate)
                                            );
                                        }
                                    },
                                    {
                                        label: staticRangesLabels.ThisYear,
                                        range: () => ({
                                            startDate: startOfYear(new Date()),
                                            endDate: endOfDay(new Date())
                                        }),
                                        isSelected(range: any) {
                                            const definedRange: any = this.range();
                                            return (
                                                isSameDay(range.startDate, definedRange.startDate) &&
                                                isSameDay(range.endDate, definedRange.endDate)
                                            );
                                        }
                                    }
                                    ]
                                    }
                                    inputRanges={ruInputRanges}
                                />
                                <div className='date-filter-buttons'>
                                    <button className='apply' onClick={toggleDatePicker}  > Apply   </button>
                                    <button className='cancel' onClick={toggleDatePicker}> Cancel  </button>
                                </div>
                            </div>
                        </div>}
                    </div>
                    <div className='search-filter'>
                        <AiOutlineSearch /><input type="text" /><span></span>
                    </div>
                </div>
                <div className='right-filter'>
                    <div className='button-filter'>
                        <button><span><AiOutlineFilter /></span><span>Filter</span></button>
                    </div>
                </div>


            </div>}
            <div className="tab-data">
                {
                    renderTabdata ? renderTabdata(activeTab) : null
                }
            </div>
        </div>
    )

}

export default DynamicTab; 